import React from 'react';
import { Toolbar } from '@mui/material';

const DSToolbar = (props: React.ComponentProps<typeof Toolbar>) => {
  return <Toolbar {...props} />;
};

export default DSToolbar;
